import { useFormContext } from "react-hook-form";
import { IVariant } from "repoV2/features/Listing/Listing.interfaces";
import { selected_merchandise_variant_form_key } from "../MerchandiseDetailsFormGroup.constants";

const useMerchandiseImages = () => {
    const { watch } = useFormContext();

    const selectedMerchandiseVariant: IVariant =
        watch(selected_merchandise_variant_form_key) || {};

    const variantImages = selectedMerchandiseVariant.images || [];

    return {
        variantImages,
    };
};

export default useMerchandiseImages;
